/* VELOURÉA · automatic Shabbat closure (Theme settings → שבת).
   Times come from sunset in the chosen city, computed in the browser (no external service).
   Friday: a notice bar at the top of every page. From candle lighting until havdalah: a closed screen. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  // NOAA-style sunset (±1–2 min) → UTC timestamp for the civil date y-m-d at lat/lng
  const sunsetUTC = (y, m, d, lat, lng) => {
    const rad = Math.PI / 180;
    const jd = Date.UTC(y, m - 1, d, 12) / 864e5 + 2440587.5;
    const n = Math.round(jd - 2451545 + 0.0008);
    const js = n - lng / 360;
    const M = (357.5291 + 0.98560028 * js) % 360;
    const C = 1.9148 * Math.sin(M * rad) + 0.02 * Math.sin(2 * M * rad) + 0.0003 * Math.sin(3 * M * rad);
    const L = (M + C + 180 + 102.9372) % 360;
    const jt = 2451545 + js + 0.0053 * Math.sin(M * rad) - 0.0069 * Math.sin(2 * L * rad);
    const dec = Math.asin(Math.sin(L * rad) * Math.sin(23.44 * rad));
    const w = Math.acos((Math.sin(-0.833 * rad) - Math.sin(lat * rad) * Math.sin(dec)) / (Math.cos(lat * rad) * Math.cos(dec)));
    return (jt + w / (2 * Math.PI) - 2440587.5) * 864e5;
  };
  const israelDate = (t) => {
    const p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Jerusalem', year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' })
      .formatToParts(new Date(t)).forEach((x) => { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday) };
  };
  const ilTime = (t) => new Intl.DateTimeFormat('he-IL', { timeZone: 'Asia/Jerusalem', hour: '2-digit', minute: '2-digit' }).format(new Date(t));
  const ss = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* noop */ } } };

  class VShabbat extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; // re-attached by lock()
      this.ready = true;
      this.lat = Number(this.dataset.lat); this.lng = Number(this.dataset.lng);
      this.candle = Number(this.dataset.candle) * 6e4; this.havdalah = Number(this.dataset.havdalah) * 6e4;
      this.design = !!(window.Shopify && window.Shopify.designMode);
      const q = location.search;
      this.forceLock = q.includes('shabbat=1');
      this.forceNotice = q.includes('shabbat=notice');
      this.check();
    }
    range(now) {
      // current or next Shabbat: Friday sunset − candle → Saturday sunset + havdalah (Israel dates)
      const t = israelDate(now);
      const back = t.wd === 6 ? 1 : t.wd === 5 ? 0 : -((5 - t.wd + 7) % 7);
      const fri = new Date(Date.UTC(t.y, t.m - 1, t.d - back));
      const sat = new Date(fri.getTime() + 864e5);
      const start = sunsetUTC(fri.getUTCFullYear(), fri.getUTCMonth() + 1, fri.getUTCDate(), this.lat, this.lng) - this.candle;
      const end = sunsetUTC(sat.getUTCFullYear(), sat.getUTCMonth() + 1, sat.getUTCDate(), this.lat, this.lng) + this.havdalah;
      if (now > end) return this.range(now + 2 * 864e5); // Saturday night after havdalah → next week
      return { start, end };
    }
    check() {
      clearTimeout(this.next);
      const now = Date.now();
      const { start, end } = this.range(now);
      if (this.forceLock) return this.lock(now + 36e5);
      if (!this.design && now >= start && now < end) return this.lock(end);
      this.unlock();
      const friday = israelDate(now).wd === 5;
      if (this.dataset.notice === 'true' && ((friday && now < start) || this.design || this.forceNotice)) this.notice(start, end);
      const left = start - now;
      if (!this.design && left > 0 && left < 864e5) this.next = setTimeout(() => this.check(), left + 500);
    }
    lock(end) {
      const bar = document.getElementById('ShabbatBar'); if (bar) bar.remove();
      const screen = $('[data-screen]', this);
      this.hidden = false; screen.hidden = false;
      document.documentElement.classList.add('shabbat-on');
      if (document.body.lastElementChild !== this) document.body.appendChild(this);
      [...document.body.children].forEach((c) => { if (c !== this && c.tagName !== 'SCRIPT') c.inert = true; });
      const timer = $('shabbat-timer', this);
      if (timer && timer.start) timer.start(end);
      else customElements.whenDefined('shabbat-timer').then(() => { const t = $('shabbat-timer', this); if (t && t.start) t.start(end); });
      this.addEventListener('shabbat:end', () => setTimeout(() => location.reload(), 4000), { once: true });
    }
    unlock() {
      const screen = $('[data-screen]', this); if (screen) screen.hidden = true;
      if (document.documentElement.classList.contains('shabbat-on')) [...document.body.children].forEach((c) => { c.inert = false; });
      document.documentElement.classList.remove('shabbat-on');
    }
    notice(start, end) {
      if (!this.design && !this.forceNotice && ss.get('v-shab-bar') === String(start)) return;
      if (document.getElementById('ShabbatBar')) return;
      const tpl = $('template[data-bar]', this);
      if (!tpl) return;
      const bar = tpl.content.firstElementChild.cloneNode(true);
      $('[data-bar-msg]', bar).textContent = this.dataset.noticeText.replace('[[start]]', ilTime(start)).replace('[[end]]', ilTime(end));
      $('[data-bar-close]', bar).addEventListener('click', () => { bar.remove(); ss.set('v-shab-bar', String(start)); });
      document.body.prepend(bar);
    }
  }
  if (!customElements.get('v-shabbat')) customElements.define('v-shabbat', VShabbat);
})();
